module.exports = require('./dist/echarts-amap.min.js')



//////////////////
// WEBPACK FOOTER
// ./node_modules/_echarts-amap@1.0.0-rc.6@echarts-amap/index.js
// module id = Nl+K
// module chunks = 48